import * as G from "./index.es5499.js";
import t from "lodash";
import { stringToRGBArray as C } from "./index.es521.js";
const R = {}, O = [
  "DEMOGRAPHICS_BLUE_4",
  "DEMOGRAPHICS_BLUE_5",
  "DEMOGRAPHICS_BLUE_6",
  "DEMOGRAPHICS_GREEN_BLUE_4",
  "DEMOGRAPHICS_GREEN_BLUE_5",
  "DEMOGRAPHICS_GREEN_BLUE_6",
  "DEMOGRAPHICS_GRAY_4",
  "DEMOGRAPHICS_GRAY_5",
  "DEMOGRAPHICS_GRAY_6",
  "DEMOGRAPHICS_PEACH_4",
  "DEMOGRAPHICS_PEACH_5",
  "DEMOGRAPHICS_PEACH_6",
  "DEMOGRAPHICS_PINK_PURPLE_4",
  "DEMOGRAPHICS_PINK_PURPLE_5",
  "DEMOGRAPHICS_PINK_PURPLE_6",
  "DEMOGRAPHICS_PURPLE_4",
  "DEMOGRAPHICS_PURPLE_5",
  "DEMOGRAPHICS_PURPLE_6",
  "DEMOGRAPHICS_TEAL_4",
  "DEMOGRAPHICS_TEAL_5",
  "DEMOGRAPHICS_TEAL_6",
  "DEMOGRAPHICS_YELLOW_GREEN_4",
  "DEMOGRAPHICS_YELLOW_GREEN_5",
  "DEMOGRAPHICS_YELLOW_GREEN_6",
  "DEMOGRAPHICS_YELLOW_RED_PURPLE_4",
  "DEMOGRAPHICS_YELLOW_RED_PURPLE_5",
  "DEMOGRAPHICS_YELLOW_RED_PURPLE_6"
];
for (const _ of O) {
  const E = _, P = E.split("_").slice(1, -1).join("-").toLowerCase(), A = _;
  R[E] = {
    paletteName: t.startCase(P),
    paletteColors: C(G[A])
  };
}
const L = (_) => Object.entries(R).map(([E, P]) => E.includes(_.toString()) ? P : void 0).filter((E) => E);
export {
  R as DEMOGRAPHIC_PALETTE_DICTIONARY,
  L as getDemographicPalettesDictionary,
  O as paletteKeys
};
//# sourceMappingURL=index.es47.js.map
